import { useEffect, useState } from 'react'
import { nowMs } from '../utils/date-utils.ts'

/** The wall clock in epoch milliseconds, re-read every `intervalMs` while `isTicking`; otherwise it stands still. */
export const useNow = ({ intervalMs = 1_000, isTicking }: { intervalMs?: number; isTicking: boolean }) => {
  const [now, setNow] = useState(nowMs)
  useEffect(() => {
    if (!isTicking) {
      return
    }
    const timer = setInterval(() => setNow(nowMs()), intervalMs)
    return () => clearInterval(timer)
  }, [intervalMs, isTicking])
  return now
}
